import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { checkinSelectReducer } from './checkin-select.reducer';
import { CHECKIN_SELECT_STORE_NAME, CheckinSelectState } from './checkin-select.state';

/** Token of the CheckinSelect reducer */
export const CHECKIN_SELECT_REDUCER_TOKEN = new InjectionToken<ActionReducer<CheckinSelectState, Action>>(
  'Feature CheckinSelect Reducer'
);

/** Provide default reducer for CheckinSelect store */
export function getDefaultCheckinSelectReducer() {
  return checkinSelectReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(CHECKIN_SELECT_STORE_NAME, CHECKIN_SELECT_REDUCER_TOKEN)],
  providers: [{ provide: CHECKIN_SELECT_REDUCER_TOKEN, useFactory: getDefaultCheckinSelectReducer }],
})
export class CheckinSelectStoreModule {
  public static forRoot<T extends CheckinSelectState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinSelectStoreModule> {
    return {
      ngModule: CheckinSelectStoreModule,
      providers: [{ provide: CHECKIN_SELECT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
